export default __webpack_public_path__ + "resources/icons/d410-9487.png";